export default __webpack_public_path__ + "static/media/ICON_Myprofile.c5addc74.svg";